module.exports = __webpack_public_path__ + "static/media/Sophie_Hello.beccb0c4.mp3";